import styled from 'styled-components';
export const Item = styled.div `
  display: flex;
  padding: 8px 8px;
  justify-content: space-between;
  background: var(--bg-secondary);
  border-radius: var(--radius-brand);
  cursor: pointer;
`;
export const Wrapper = styled.div `
  align-self: center;
`;
export const Container = styled.div `
  display: flex;
  gap: 24px;
  align-self: center;
`;
export const Text = styled.div `
  display: flex;
  flex-direction: column;
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-400);
`;
